import React, { useEffect, useState } from "react";
import {
  Grid,
  Divider,
  Typography,
  Box,
  Link,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Facebook, Twitter, Instagram } from "@mui/icons-material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import darklogoImage from "../../../components/DarkBackground.webp";
import { YouTube } from "@mui/icons-material";
export default function Footer() {
  const theme = useTheme();
  const isLarge = useMediaQuery("(min-width: 1920px)");
  const isUltraWide = useMediaQuery("(max-width: 2560px)");
  const is2XLarge = useMediaQuery("(min-width: 3840px)");
  const isMobile = useMediaQuery("(max-width: 495px)");
  const isTablet = useMediaQuery("(max-width: 768px)");
  const isMidScreen = useMediaQuery('(min-width:1150px) and (max-width:1332px)');
  const isbelowMidScreen = useMediaQuery('(min-width:900px) and (max-width:1151px)');
  const [websiteBaseUrl, setWebsiteBaseUrl] = useState("");
  const [fullServicesData, setFullServicesData] = useState([]);
  const [fullCompanyData, setFullCompanyData] = useState([]);

  const fetchWebsiteURL = async () => {
    const cacheKey = "cachedWebsiteUrl";
    const cached = localStorage.getItem(cacheKey);

    if (cached) return cached;

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-config`);
      const data = await res.json();
      const website = data.website || "";
      localStorage.setItem(cacheKey, website);
      return website;
    } catch (err) {
      console.error("Fetch config error", err);
      return "";
    }
  };

  useEffect(() => {
    if (fullServicesData.length === 0 && fullCompanyData.length === 0) {
      fetchWebsiteURL().then((website) => {
        const services = [
          { title: "Cloud Solutions", to: website + "service/cloud-solutions" },
          { title: "Applied AI", to: website + "service/applied-ai" },
          { title: "Data Solutions", to: website + "service/data-solutions" },
        ];
        const company = [
          { title: "About DevAngles", to: website + "about" },
          { title: "Let's Talk", to: website + "contact" },
          { title: "Alliance", to: website + "alliance" },
          { title: "Join Us", to: website + "joinus" },
        ];
        setFullServicesData(services);
        setFullCompanyData(company);
        setWebsiteBaseUrl(website);
      });
    }
  }, [fullServicesData, fullCompanyData]);

  return (
    <Box
      sx={{
        backgroundColor: "#00002D",
        width: "100%",
        display: "flex",
        justifyContent: {
          xs: "flex-start",
          sm: "flex-start",
          md: "center",
        },
        alignItems: {
          xs: "flex-start",
          sm: "flex-start",
          md: "center",
        },
        height: {
          xs: "650px",
          sm: "800px",
          md: "100%",
        },
      }}
    >
      <Box
        sx={{
          maxWidth: "100%",
          margin: isMobile
            ? "50px 0px"
            : is2XLarge
            ? "50px 850px"
            : isTablet
            ? "50px 0"
            : "50px 70px",
            paddingX: isTablet ? "4%" : isbelowMidScreen? "1%": isMidScreen ? "7%": "8%",
        }}
      >
        <Grid container spacing={2.5} justifyContent="space-between">
          {/* Logo & Description */}
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Box
              component="img"
              src={darklogoImage}
              alt="DevAngles logo – Delivering simple, innovative, and excellent digital IT solutions"
              loading="eager"
              sx={{
                width: is2XLarge || isLarge ? 350 : 250,
                height: 22,
                marginBottom: 2,
              }}
            />
            <Typography
              sx={{
                color: "#FFFFFFDB",
                fontSize: { xs: "14px", md: "16px" },
                fontWeight: "300 !important",
                lineHeight: 1.5,
                fontDisplay: "swap",
                willChange: "transform",
                fontFamily: '"Lexend"',
                "&::before": {
                  content: '""',
                  display: "block",
                  height: 0,
                  visibility: "hidden",
                },
              }}
            >
              We help organizations unlock new business opportunities and
              enhance customer journeys with cloud, data, and AI driven
              insights.
            </Typography>
          </Grid>

          {/* Services Links */}
          <Grid item xs={6} sm={4} md={2} lg={2}>
            <QuickLinks
              title="What We Do"
              links={fullServicesData}
              sx={{ fontWeight: 500, fontFamily: '"Lexend", sans-serif' }}
              fontSize={
                is2XLarge
                  ? "33px"
                  : isLarge
                  ? "18px"
                  : isMobile
                  ? "16px"
                  : isTablet
                  ? "18px"
                  : "20px"
              }
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2} lg={2}>
            <QuickLinks
              title="Who We Are"
              links={fullCompanyData}
              sx={{ fontWeight: 500, fontFamily: '"Lexend", sans-serif' }}
              fontSize={
                is2XLarge
                  ? "33px"
                  : isLarge
                  ? "18px"
                  : isMobile
                  ? "16px"
                  : isTablet
                  ? "18px"
                  : "20px"
              }
            />
          </Grid>
          {/* Contact Us section */}
 
          <Grid item xs={12} sm={4} md={2} lg={2}>
 
            <ContactInfo
              fontSize={
                is2XLarge
                  ? "33px"
                  : isLarge
                  ? "18px"
                  : isMobile
                  ? "16px"
                  : isTablet
                  ? "18px"
                  : "20px"
              }
            />
          </Grid>
        </Grid>

        {/* Footer Bottom */}
        <Divider sx={{ my: 4, borderColor: "rgba(255, 255, 255, 0.86)" }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "start",
            alignItems: "start",
            flexWrap: "wrap",
            gap: 1.5,
            textAlign: "center",
            py: 2,
          }}
        >
          <Typography
            sx={{
              color: "#FFFFFFD9",
              fontWeight: 300,
              fontSize: is2XLarge
                ? "20px"
                : isLarge
                ? "16px"
                : isMobile
                ? "13px"
                : isTablet
                ? "13px"
                : "14px",
              fontFamily: '"Lexend", sans-serif',
            }}
          >
            © {new Date().getFullYear()} DevAngles. All rights reserved.
          </Typography>
          <Box>
            <Link
              href={`${websiteBaseUrl}privacy-policy`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
              sx={{ fontFamily: '"Lexend", sans-serif' }}
            >
              <Typography
                sx={{
                  color: "#FFFFFFD9",
                  fontWeight: 300,
                  fontSize: is2XLarge
                    ? "20px"
                    : isLarge
                    ? "16px"
                    : isMobile
                    ? "13px"
                    : isTablet
                    ? "13px"
                    : "14px",
                  cursor: "pointer",
                  fontFamily: '"Lexend", sans-serif',
                }}
              >
               |&nbsp;&nbsp;Privacy Policy
              </Typography>
            </Link>
          </Box>
          <Box>
            <Link
              href={`${websiteBaseUrl}terms-of-use`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
              sx={{ fontFamily: '"Lexend", sans-serif' }}
            >
              <Typography
                sx={{
                  color: "#FFFFFFD9",
                  fontWeight: 300,
                  fontSize: is2XLarge
                    ? "20px"
                    : isLarge
                    ? "16px"
                    : isMobile
                    ? "13px"
                    : isTablet
                    ? "13px"
                    : "14px",
                  cursor: "pointer",
                  fontFamily: '"Lexend", sans-serif',
                }}
              >
                |&nbsp;&nbsp;Terms of Use
              </Typography>
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

function QuickLinks({ title, links, fontSize, sx }) {
  const isLarge = useMediaQuery("(min-width: 1920px)");
  const isUltraWide = useMediaQuery("(max-width: 2560px)");
  const is2XLarge = useMediaQuery("(min-width: 3840px)");
  const isMobile = useMediaQuery("(max-width: 495px)");
  const isTablet = useMediaQuery("(max-width: 768px)");

  return (
    <Box sx={{ color: "#FFFFFFD9" }}>
      <Typography
        variant="h6"
        sx={{
          // fontWeight: "bold",
          marginBottom: 1.5,
          fontFamily: '"Lexend", sans-serif',
          ...sx,
        }}
      >
        {title}
      </Typography>
      <Box>
        {links.map((link, index) => (
          <Link
            key={index}
            href={link.to}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: "block",
              color: "#FFFFFFD9",
              textDecoration: "none",
              marginBottom: 2.7,
              fontSize: is2XLarge
                ? "20px"
                : isLarge
                ? "14px"
                : isMobile
                ? "13px"
                : isTablet
                ? "13px"
                : "14px",
              fontFamily: '"Lexend", sans-serif',
              "&:hover, &:focus": {
                textDecoration: "underline",
              },
            }}
          >
            {link.title}
          </Link>
        ))}
      </Box>
    </Box>
  );
}

function ContactInfo({ fontSize }) {
  const isLarge = useMediaQuery("(min-width: 1920px)");
  const isUltraWide = useMediaQuery("(max-width: 2560px)");
  const is2XLarge = useMediaQuery("(min-width: 3840px)");
  const isMobile = useMediaQuery("(max-width: 495px)");
  const isTablet = useMediaQuery("(max-width: 768px)");

  return (
    <Box sx={{ color: "#FFFFFFD9" }}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 500,
          marginBottom: 1.5,
          fontFamily: '"Lexend", sans-serif',
        }}
      >
        Contact Us
      </Typography>
      <Box>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 300,
            marginBottom: 1.5,
            fontSize: is2XLarge
              ? "20px"
              : isLarge
              ? "14px"
              : isMobile
              ? "13px"
              : isTablet
              ? "13px"
              : "14px",
            fontFamily: '"Lexend", sans-serif',
          }}
        >
          <strong>Phone:</strong>{" "}
          <Link
            href="tel:+6545667543"
            sx={{
              color: "#FFFFFFD9",
              textDecoration: "none",
              fontFamily: '"Lexend", sans-serif',
            }}
          >
            +91-20-4863 6888
          </Link>
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 300,
            fontSize: is2XLarge
              ? "20px"
              : isLarge
              ? "14px"
              : isMobile
              ? "13px"
              : isTablet
              ? "13px"
              : "14px",
            fontFamily: '"Lexend", sans-serif',
          }}
        >
          <strong>Email:</strong>{" "}
          <Link
            href="mailto:contact@devangles.com"
            sx={{
              color: "#FFFFFFD9",
              textDecoration: "none",
              fontFamily: '"Lexend", sans-serif',
            }}
          >
            contact@devangles.com
          </Link>
        </Typography>

        {/* Social Links */}
        <Box sx={{ display: "flex", gap: 2, marginTop: 2 }}>
        <Link
            href="https://in.linkedin.com/company/dev-angles"
            aria-label="LinkedIn"
          >
            <LinkedInIcon sx={{ width: 24, height: 24, color: "#FFFFFFD9" }} />
          </Link> 
          <Link href="https://www.youtube.com/@DevanglesSoftware" aria-label="YouTube">
          <YouTube sx={{ width: 24, height: 24, color: "#FFFFFFD9" }} />
          </Link>
          <Link href="https://x.com/DevAnglesTeam" aria-label="Twitter">
            <XIcon sx={{ fontSize, color: "#FFFFFFD9" }} />
          </Link>
          {/* <Link href="#" aria-label="Instagram" sx={{ fontFamily: '"Lexend", sans-serif' }}>
            <Instagram sx={{ fontSize, color: "#FFFFFFD9" }} />
          </Link> */}
        </Box>
      </Box>
    </Box>
  );
}